/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Label, InputField } from 'components';
import './style.scss';

function Field({
  name = '',
  label = null,
  value = undefined,
  placeholder = '',
  type = '',
  fieldType = '',
  options = [<option value="">Vilaj</option>],
  onChange = () => {},
  onBlur = () => {},
  className = {
    inputClass: '',
    labelClass: '',
    containerClass: '',
    errorClass: '',
  },
  onKeyUp = () => {},
  error = null,
  showIcon = false,
  icon = null,
  disabled = false,
  ...rest
}) {
  return (
    <div className={`${className.containerClass} tv-field__container`}>
      {label && (
        <Label
          htmlFor={name}
          className={`${className.labelClass} tv-field__label`}
          labelName={label}
        />
      )}
      <InputField
        name={name}
        id={name}
        value={value}
        placeholder={placeholder}
        type={type}
        fieldType={fieldType}
        className={`${className.inputClass}  tv-field__input ${
          error && 'tv-field__input--error'
        }`}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        options={options}
        disabled={disabled}
        {...rest}
      />
      {showIcon && <i className="material-icons">{icon}</i>}
      {error && (
      <div className={`${className.errorClass}  tv-field__error`}>{error} </div>
      )}
    </div>
  );
}

Field.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.node,
  fieldType: PropTypes.string,
  onBlur: PropTypes.func,
  style: PropTypes.shape({}),
  onKeyUp: PropTypes.func,
  error: PropTypes.string,
  icon: PropTypes.string,
  showIcon: PropTypes.bool,
  className: PropTypes.shape({
    inputClass: PropTypes.string,
    labelClass: PropTypes.string,
    containerClass: PropTypes.string,
    errorClass: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

export default Field;
